'use client'

import cn from 'classnames';
import { usePathname } from 'next/navigation';
import { FC } from 'react';
import IconGridBreakup from '../IconGridBreakup';
import { BottomSection } from './BottomSection';
import { FooterProps } from './Footer.types';
import { getFooterBackgroundColor, shouldHideFooterPatternOnPagePath } from './Footer.utils';
import { LegalLinksSection } from './LegalLinksSection';
import { SmallLinksSection } from './SmallLinksSection';
import { TopSection } from './TopSection';

const Footer: FC<FooterProps> = ({
  backgroundColor = 'violet',
  hideTopPattern = false,
  tagline,
  badgeIcons = [],
  socialLinks = [],
  linkColumns = [],
  smallLinksTitle,
  smallLinkColumns = [],
  legalLinks = [],
  copyright,
}) => {
  const pathname = usePathname();

  return (
    <footer className={cn(getFooterBackgroundColor(pathname!), 'overflow-hidden')}>
      {!hideTopPattern && !shouldHideFooterPatternOnPagePath(pathname!) && (
        <div className="h-30 md:h-[21vw] relative w-full overflow-hidden">
          <IconGridBreakup className="absolute left-[-100vw] right-[-100vw] bottom-[-1px] w-[300vw] md:left-0 md:right-0 md:w-full h-auto text-violet-800" />
        </div>
      )}

      <TopSection backgroundColor={backgroundColor} tagline={tagline} badgeIcons={badgeIcons} socialLinks={socialLinks} linkColumns={linkColumns} />

      <BottomSection backgroundColor={backgroundColor}>
        <SmallLinksSection smallLinksTitle={smallLinksTitle} smallLinkColumns={smallLinkColumns} backgroundColor={backgroundColor} />
        <LegalLinksSection backgroundColor={backgroundColor} copyright={copyright} legalLinks={legalLinks} />
      </BottomSection>
    </footer>
  );
};

export default Footer;
